// src/pages/auth/ResetPassword.jsx
import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Footer from '../components/Footer';
import { appNavigation, urlMap } from '../../utils';

class ResetPassword extends Component {
  state = {
    email: '',
    token: '',
    password: '',
    repeatPassword: '',
    error: '',
    success: '',
    submitting: false,
  };

  componentDidMount() {
    const params = new URLSearchParams(window.location.search);
    const email = (params.get('email') || '').toLowerCase();
    const token = params.get('token') || '';

    this.setState({
      email,
      token,
      error: email && token ? '' : 'Invalid reset link. Please request a new one.',
    });
  }

  handleChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
      error: '',
      success: '',
    });
  };

  handleSubmit = async (e) => {
    e.preventDefault();
    const { email, token, password, repeatPassword } = this.state;

    if (!email || !token) {
      this.setState({ error: 'Invalid or missing reset token. Request a new link.' });
      return;
    }
    if (password.length < 8) {
      this.setState({ error: 'Password must be at least 8 characters.' });
      return;
    }
    if (password !== repeatPassword) {
      this.setState({ error: 'Passwords do not match.' });
      return;
    }

    this.setState({ submitting: true, error: '', success: '' });

    try {
      const res = await fetch(urlMap.resetPassword, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, token, newPassword: password }),
      });

      const data = await res.json();

      if (!res.ok) {
        throw new Error(data.message || 'Failed to reset password');
      }

      this.setState({
        success: '✅ Password has been reset. You can now log in with your new password.',
        error: '',
        password: '',
        repeatPassword: '',
        submitting: false,
      });
    } catch (err) {
      this.setState({
        error: err.message || 'Something went wrong. Please try again.',
        submitting: false,
      });
    }
  };

  render() {
    const { email, password, repeatPassword, error, success, submitting, token } = this.state;

    return (
      <div className="login-page">
        <div className="login-wrapper">
          <form className="login-form" onSubmit={this.handleSubmit}>
            <h2>Reset Password</h2>
            <p className="subtitle">Enter a new password for your account</p>

            {/* Show email (readonly) to reassure the user */}
            <input
              type="email"
              name="email"
              placeholder="Email"
              value={email}
              readOnly
            />

            {/* Keep token hidden but present */}
            <input type="hidden" name="token" value={token} />

            <input
              type="password"
              name="password"
              placeholder="New password"
              value={password}
              onChange={this.handleChange}
              required
              minLength={8}
            />

            <input
              type="password"
              name="repeatPassword"
              placeholder="Repeat new password"
              value={repeatPassword}
              onChange={this.handleChange}
              required
              minLength={8}
            />

            {error && <p className="error-message">{error}</p>}
            {success && <p className="success-message">{success}</p>}

            <button type="submit" disabled={submitting || !email || !token}>
              {submitting ? 'Updating…' : 'Update Password'}
            </button>

            <p className="footer-text">
              <Link to={appNavigation.login}>← Back to Login</Link>
            </p>
          </form>
        </div>

        <Footer />
      </div>
    );
  }
}

export default ResetPassword;
